export default __webpack_public_path__ + "static/media/copyIcon.344b7025.svg";